angular.module('lf.desktop')

.directive('productPod', function () {
  return {
    scope: true,
    link: function (scope, el, attrs) {
      var data = $.extend({}, el.data());
      delete data.$scope;
      scope.product = data;
    }
  }
});
